<template>
	<div v-if="message != ''" class="px-3 py-2 border radius-0 text-center d-block mb-3" style="background-color: rgb(255, 210, 195); border-color: rgb(247, 111, 111) !important;">
    <p class="mb-0 body-2-1 w-75 mx-auto">{{message}}</p>
  </div>
</template>
<script>
	export default{
		props: ['message']
	}
</script>



// WEBPACK FOOTER //
// src/components/hotel/concierge/general/ErrorMessage.vue